<template>
  <div class="legend">
    <div>
      <input type="range" class="slider" v-model="minDN" min="1" max="4">
    </div>

    <div class="descriptions"> 
      <div @click="minDN = 4"><span class="legend-fill" style="background: #228E10"></span>Sehr gut</div>
      <div @click="minDN = 3"><span class="legend-fill" style="background: #A5C823"></span>Deep Indoor</div>
      <div @click="minDN = 2"><span class="legend-fill" style="background: #EECA2C"></span>Indoor</div>
      <div @click="minDN = 1"><span class="legend-fill" style="background: #F8952A"></span>Outdoor</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      minDN: 1
    }
  },
  watch: {
    minDN(nv) {
      this.updateFilter(nv)
    }
  },
  methods: {
    updateFilter(min) {
      let filter = [">=", ["get", "dn"], min * 1]
      this.map.setFilter("coverage-data", filter)
    }
  }
}
</script>

<style scoped>
  .legend {
    background: white;
    border-radius: 6px;
    padding: 8px;
    display: flex;
    flex-direction: row;
  }

  .legend > .descriptions {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .legend > .descriptions > div {
    cursor: pointer;
  }

  .slider {
    writing-mode: bt-lr; /* IE */
    -webkit-appearance: slider-vertical; /* WebKit */
    width: 20px;
    height: 8em;
  }

  .legend-fill {
    display: inline-block;
    vertical-align: text-top;
    height: 1em;
    width: 3ch;
    margin-right: 1ch;
  }
</style>


// WEBPACK FOOTER //
// src/components/Legend.vue